enum TrafficOverallChangeMetric {
    MonthlyVisits = "monthly_visits",
    TotalPageViews = "total_page_views",
    UniqueMonthlyVisitors = "unique_monthly_visitors",
}

export default TrafficOverallChangeMetric;
